<template>
  <div>
    <form class="form-horizontal">
      <!-- Row 2: Academic Year & Main Program -->
      <div class="row">
        <div class="col-md-6 mb-2">
          <label class="block text-sm font-semibold text-gray-800 mb-2">
            {{ $t('invoice.academicYear') }}
            <span class="ts-text-red-500">*</span>
          </label>
          <input
            type="text"
            readonly
            class="ts-w-full ts-px-3 ts-py-2 ts-bg-gray-50 ts-border ts-border-gray-200 ts-rounded-lg ts-text-gray-700 focus:ts-outline-none focus:ts-ring-2 focus:ts-ring-blue-500 focus:ts-border-transparent"
            :value="academic.ac_year"
          />
          <div class="ts-text-red-500 text-xs mt-1" v-if="errors.has('ac_year_id')">
            {{ errors.first('ac_year_id') }}
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <label class="block text-sm font-semibold text-gray-800 mb-2">
            {{ $t('invoice.mainProgram') }}
            <span class="ts-text-red-500">*</span>
          </label>
          <input
            type="text"
            readonly
             class="ts-w-full ts-px-3 ts-py-2 ts-bg-gray-50 ts-border ts-border-gray-200 ts-rounded-lg ts-text-gray-700 focus:ts-outline-none focus:ts-ring-2 focus:ts-ring-blue-500 focus:ts-border-transparent"
            :value="academic.main_program"
          />
          <div class="ts-text-red-500 text-xs mt-1" v-if="errors.has('acp_id')">
            {{ errors.first('acp_id') }}
          </div>
        </div>
      </div>
      <!-- Row 1: Student Name & Grade -->
      <div class="row">
        <div class="col-md-6 mb-2">
          <label class="block text-sm font-semibold text-gray-800 mb-2">
            {{ $t('invoice.studentName') }}
            <span class="ts-text-red-500">*</span>
          </label>
          <input
            type="text"
            readonly
             class="ts-w-full ts-px-3 ts-py-2 ts-bg-gray-50 ts-border ts-border-gray-200 ts-rounded-lg ts-text-gray-700 focus:ts-outline-none focus:ts-ring-2 focus:ts-ring-blue-500 focus:ts-border-transparent"
            :value="academic.student_name"
          />
          <div class="ts-text-red-500 text-xs mt-1" v-if="errors.has('student_id')">
            {{ errors.first('student_id') }}
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <label class="block text-sm font-semibold text-gray-800 mb-2">
            {{ $t('invoice.grade') }}
            <span class="ts-text-red-500">*</span>
          </label>
          <input
            type="text"
            readonly
             class="ts-w-full ts-px-3 ts-py-2 ts-bg-gray-50 ts-border ts-border-gray-200 ts-rounded-lg ts-text-gray-700 focus:ts-outline-none focus:ts-ring-2 focus:ts-ring-blue-500 focus:ts-border-transparent"
            :value="academic.grade"
          />
          <div class="ts-text-red-500 text-xs mt-1" v-if="errors.has('grade_id')">
            {{ errors.first('grade_id') }}
          </div>
        </div>
      </div>

      <!-- Row 3: Academic Term & Study Time -->
      <div class="row">
        <div class="col-md-6 mb-2">
          <label class="block text-sm font-semibold text-gray-800 mb-2">
            {{ $t('invoice.acTerm') }}
            <span class="ts-text-red-500">*</span>
             <small
            v-if="model.ac_term_stop_date"
            class="ts-pl-1 ts-rounded-bl-sm ts-font-semibold  ts-text-blue-600 ts-text-xs block mt-1 px-2 py-1 bg-blue-50"
          >{{
            $t('invoice.endDate') + ' : ' + model.ac_term_stop_date
          }}</small>
          </label>
          <input
            type="text"
            readonly
              class="ts-w-full ts-px-3 ts-py-2 ts-bg-gray-50 ts-border ts-border-gray-200 ts-rounded-lg ts-text-gray-700 focus:ts-outline-none focus:ts-ring-2 focus:ts-ring-blue-500 focus:ts-border-transparent"
            :value="academic.ac_term"
          />
         
          <div class="ts-text-red-500 text-xs mt-1" v-if="errors.has('ac_term')">
            {{ errors.first('ac_term') }}
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <label class="block text-sm font-semibold text-gray-800 mb-2">
            {{ $t('invoice.studyTime') }}
            <span class="ts-text-red-500">*</span>
          </label>
          <input
            type="text"
            readonly
             class="ts-w-full ts-px-3 ts-py-2 ts-bg-gray-50 ts-border ts-border-gray-200 ts-rounded-lg ts-text-gray-700 focus:ts-outline-none focus:ts-ring-2 focus:ts-ring-blue-500 focus:ts-border-transparent"
            :value="academic.study_time"
          />
        </div>
      </div>

      <!-- Row 4: Invoice Date & Promotion Expired Date -->
      <div class="row">
        <div class="col-md-6">
          <label class="block text-sm font-semibold text-gray-800 mb-2">
            {{ $t('invoice.invoiceDate') }}
            <span class="ts-text-red-500">*</span>
          </label>
          <a-date-picker
            :style="{ width: '100%', height: '40px' }"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            v-model="model.inv_date"
            class="rounded-lg"
          />
          <div class="ts-text-red-500 text-xs mt-1" v-if="errors.has('inv_date')">
            {{ errors.first('inv_date') }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="block text-sm font-semibold text-gray-800 mb-2">
            {{ $t('invoice.proExpDate') }}
          </label>
          <a-date-picker
            v-model="model.promtion_expired_date"
            :disabled="true"
            :style="{ width: '100%', height: '40px' }"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            class="rounded-lg"
          />
        </div>
      </div>

      <!-- Bus Fee Notification -->
      <div class="row ts-mt-1" v-if="vehicleRegister">
        <div class="col-md-12">
          <div class="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-400 p-4 rounded-r-lg shadow-sm">
            <div class="flex items-center">
              <i class="fa fa-bus text-blue-500 text-lg mr-3"></i>
              <span class="text-red-600 font-medium text-sm">
                {{ $t('invoice.studnetTakeBuseFee') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'academicInfo',
  props: ['value', 'academic', 'validate', 'vehicleRegister'],
  data() {
    return {
      model: {},
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
.container {
  max-height: 35vh;
  height: 30vh;
}

.form-control-plaintext {
  border: none;
  background-color: transparent;
}

.required::after {
  content: " *";
  color: #dc3545;
}
</style>